import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\GravePlot\UpdateGravePlotController::__invoke
* @see app/Http/Controllers/GravePlot/UpdateGravePlotController.php
* @route '/api/grave-plot/{grave_plot}'
*/
const UpdateGravePlotController = (args: { grave_plot: string | number | { id: string | number } } | [grave_plot: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateGravePlotController.url(args, options),
    method: 'put',
})

UpdateGravePlotController.definition = {
    methods: ["put"],
    url: '/api/grave-plot/{grave_plot}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\GravePlot\UpdateGravePlotController::__invoke
* @see app/Http/Controllers/GravePlot/UpdateGravePlotController.php
* @route '/api/grave-plot/{grave_plot}'
*/
UpdateGravePlotController.url = (args: { grave_plot: string | number | { id: string | number } } | [grave_plot: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { grave_plot: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { grave_plot: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            grave_plot: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        grave_plot: typeof args.grave_plot === 'object'
        ? args.grave_plot.id
        : args.grave_plot,
    }

    return UpdateGravePlotController.definition.url
            .replace('{grave_plot}', parsedArgs.grave_plot.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\GravePlot\UpdateGravePlotController::__invoke
* @see app/Http/Controllers/GravePlot/UpdateGravePlotController.php
* @route '/api/grave-plot/{grave_plot}'
*/
UpdateGravePlotController.put = (args: { grave_plot: string | number | { id: string | number } } | [grave_plot: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateGravePlotController.url(args, options),
    method: 'put',
})

export default UpdateGravePlotController